// Sigil brand mark + lockup. Subset of the full component used by the iframe.
import type { CSSProperties } from 'react';

type Variant = 'mark' | 'lockup';
type Color = 'black' | 'blue' | 'white';

const HEX: Record<Color, string> = {
  black: '#0A0A0F',
  blue: '#1E50E0',
  white: '#FAFAFA',
};

export function Logo({
  variant = 'lockup',
  color = 'black',
  size = 28,
  showBlueLine = true,
}: {
  variant?: Variant;
  color?: Color;
  size?: number;
  showBlueLine?: boolean;
}) {
  const fill = HEX[color];
  const tiny = size <= 24;
  const outerStroke = tiny ? 6 : 4;
  const innerStroke = tiny ? 2.5 : 1.5;
  const sideDot = tiny ? 9 : 7.5;
  const rightDot = tiny ? 7 : 6;

  const mark = (
    <svg viewBox="0 0 100 100" width={size} height={size} fill="none" aria-hidden="true">
      <circle cx="50" cy="50" r="47" stroke={fill} strokeWidth={outerStroke} />
      <circle cx="50" cy="50" r="24" stroke={fill} strokeWidth={innerStroke} />
      <circle cx="38" cy="29.2" r={sideDot} fill={fill} />
      <circle cx="38" cy="70.8" r={sideDot} fill={fill} />
      <circle cx="74" cy="50" r={rightDot} fill={fill} />
    </svg>
  );
  if (variant === 'mark') return mark;

  const wordSize = Math.round(size * 0.62);
  const wordStyle: CSSProperties = {
    fontSize: wordSize,
    color: fill,
    lineHeight: 1,
    fontWeight: 600,
    letterSpacing: '-0.02em',
  };
  return (
    <span className="inline-flex items-center gap-2.5">
      {mark}
      <span className="inline-flex flex-col items-start gap-1">
        <span style={wordStyle}>sigil</span>
        {showBlueLine && <span className="h-0.5 w-9 bg-bit2me" />}
      </span>
    </span>
  );
}
